var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTalentSelfDevelopment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_321_200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.58 52.4302H7.00781V58.6908H13.58V52.4302Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.579 59.9999H7.00678C6.2894 59.9999 5.70508 59.4123 5.70508 58.6908V52.4301C5.70508 51.7086 6.2894 51.121 7.00678 51.121H13.579C14.2963 51.121 14.8807 51.7086 14.8807 52.4301V58.6908C14.8807 59.4123 14.2963 59.9999 13.579 59.9999ZM8.30849 57.3816H12.2773V53.7393H8.30849V57.3816Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7187 45.4772H20.1465V58.6909H26.7187V45.4772Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7176 60H20.1455C19.4281 60 18.8438 59.4123 18.8438 58.6909V45.4771C18.8438 44.7556 19.4281 44.168 20.1455 44.168H26.7176C27.435 44.168 28.0193 44.7556 28.0193 45.4771V58.6909C28.0193 59.4123 27.435 60 26.7176 60ZM21.4472 57.3817H25.4159V46.7863H21.4472V57.3817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8573 29.9535H33.2852V58.6909H39.8573V29.9535Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8563 60H33.2841C32.5667 60 31.9824 59.4123 31.9824 58.6908V29.9534C31.9824 29.232 32.5667 28.6443 33.2841 28.6443H39.8563C40.5737 28.6443 41.158 29.232 41.158 29.9534V58.6908C41.158 59.4123 40.5737 60 39.8563 60ZM34.5858 57.3817H38.5546V31.2626H34.5858V57.3817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9999 12.0908H46.4277V58.6909H52.9999V12.0908Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.995 60H46.4228C45.7054 60 45.1211 59.4123 45.1211 58.6908V12.0908C45.1211 11.3693 45.7054 10.7816 46.4228 10.7816H52.995C53.7124 10.7816 54.2967 11.3693 54.2967 12.0908V58.6908C54.2967 59.4123 53.7124 60 52.995 60ZM47.7303 57.3817H51.6991V13.3999H47.7303V57.3817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6983 60H1.30171C0.584322 60 0 59.4124 0 58.6909C0 57.9694 0.584322 57.3817 1.30171 57.3817H58.6983C59.4157 57.3817 60 57.9694 60 58.6909C60 59.4124 59.4157 60 58.6983 60Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1187 47.1295H5.27632C4.55893 47.1295 3.97461 46.5419 3.97461 45.8204C3.97461 45.0989 4.55893 44.5112 5.27632 44.5112H9.76576L22.3489 37.1858L34.5155 19.3464C34.5618 19.2766 34.6197 19.2126 34.6775 19.1486L53.8155 0.372371C54.3304 -0.133835 55.1519 -0.122198 55.6553 0.395645C56.1586 0.913488 56.147 1.73971 55.6321 2.24592L36.5925 20.9348L24.3333 38.9139C24.2234 39.0768 24.0787 39.2106 23.911 39.3037L10.7724 46.955C10.5757 47.0714 10.3501 47.1295 10.1187 47.1295Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7251 8.18076C54.0077 8.18076 53.4234 7.5931 53.4234 6.87161V2.61831H49.1943C48.4769 2.61831 47.8926 2.03064 47.8926 1.30915C47.8926 0.587665 48.4711 0 49.1943 0H54.7251C55.4425 0 56.0268 0.587665 56.0268 1.30915V6.87161C56.0268 7.5931 55.4425 8.18076 54.7251 8.18076Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_321_200"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalentSelfDevelopment);
export default __webpack_public_path__ + "static/media/talent-self-development.996a0468732ed46a37ccaab4db756956.svg";
export { ForwardRef as ReactComponent };